var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinusLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#486581",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4286 10C17.7442 10 18 10.2558 18 10.5714C18 10.887 17.7442 11.1429 17.4286 11.1429H2.57143C2.25584 11.1429 2 10.887 2 10.5714C2 10.2558 2.25584 10 2.57143 10H17.4286Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusLight);
export default __webpack_public_path__ + "static/media/minus-light.84fbbef7f3fdc6fdbbca9e91da022b72.svg";
export { ForwardRef as ReactComponent };